import { Breadcrumb } from '@/components/Atoms/Breadcrumbs'
import { Navigate, Outlet } from 'react-router'
import { Card, CardContent } from '@/components/ui/card'
import { buildPath } from '@/routes'
import { HasFeature } from '@/components/Atoms/Permissions'
import { CompaniesFeature } from '@/lib/features/companies'

export function CompaniesLayout() {
  return (
    <HasFeature
      feature={CompaniesFeature}
      noFeatureComponent={<Navigate to={buildPath('/')} />}
    >
      <Breadcrumb label="Companies" path={buildPath('/companies')} />
      <Card>
        <CardContent className="flex flex-col gap-4 lg:min-h-[500px]">
          <Outlet />
        </CardContent>
      </Card>
    </HasFeature>
  )
}
